import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

const _get = async (customerId, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer/${customerId}/contact`,
    params: params,
  })

  return response?.data
}

export const get = (customerId) => async (queryParam) => await _get(customerId, queryParam)

const _show = async (customerId, id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer/${customerId}/contact/${id}`,
  })

  return response?.data
}

export const show = (customerId) => async (id) => await _show(customerId, id)

const _store = async (customerId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/customer/${customerId}/contact`,
    data,
  })

  return response?.data
}

export const store = (customerId) => async (data) => await _store(customerId, data)

const _update = async (customerId, id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/customer/${customerId}/contact/${id}`,
    data,
  })

  return response?.data
}

export const update = (customerId) => async (id, data) => await _update(customerId, id, data)

const _deleteSingle = async (customerId, id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/customer/${customerId}/contact/${id}`,
  })

  return response?.data
}

export const deleteSingle = (customerId) => async (id) => await _deleteSingle(customerId, id)

export const deleteMany = async (ids) => {
  const responses = await Promise.map(ids.map((id) => deleteSingle(id)))

  return responses.map((response) => response?.data)
}
